<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6">
        <v-card-title class="mt-4 ml-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Value
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                @input="form.name = form.name.toUpperCase()"
                v-model="form.name"
                outlined
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.name"
              >
                <template v-slot:label>Name <span style="color:#f44336;font-weight:bold;">*</span></template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn v-else color="primary" dark @click="save">
            Update Value
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "ValueEditPage",
  data() {
    return {
      form: {},
      isLoading: false,
    };
  },
  computed: {
    errors() {
      return this.$store.getters["errors/getErrors"] || {};
    },
  },
  mounted() {
    this.$store.dispatch("errors/setErrors", {});
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let form = await axios.get(`/values/${this.$route.params.valueId}`);
      this.form = form.data.data;
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        this.$store.dispatch("errors/setErrors", {});
        await axios.patch(`/values/${this.$route.params.valueId}`, this.form);
        this.isLoading = false;
        this.$router.push("/values");
      } catch (e) {
        this.isLoading = false;
        if (e.response && e.response.data && e.response.data.errors) {
          this.$store.dispatch("errors/setErrors", e.response.data.errors);
        }
      }
    },
  },
};
</script>
